   <template>
<div>
       <Header/>

<!--End mainmenu area--> 

<!--Start breadcrumb area-->

<section class="breadcrumb-area" v-bind:style="{backgroundImage: 'url('+this.pagebanner+ ')' }">
	<div class="container text-center">
		<h1 v-if="pagedata">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</h1>
		<span class="border"></span>
	</div>
</section>
<!--End breadcrumb area-->
         
<!--Start breadcrumb bottom area--> 
<section class="breadcrumb-bottom-area">
    <div class="container">
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <a href="#"></a>    
        </div>
        <div :class="$i18n.locale == 'en' ?'right pull-left': 'right pull-right'">
            <ul>
               <li><a :href="$i18n.locale == 'en' ? '../../../../en/': '../../../../ar/'">{{ $i18n.locale == 'en' ? 'Home':'الرئيسية' }}</a></li>
               <li>></li>
                <li><a href="#">{{ $i18n.locale == 'en' ? pagedata.page_entitle:pagedata.page_artitle }}</a></li>

                
            </ul>    
        </div>        
    </div>    
</section>         
<section class="branch-area">
    <div class="container">
        <div class="branch-title pull-right">
            <h3 dir="rtl">لدينا <span> أربعة أفرع&nbsp;</span>في الكويت، إختر أقرب فرع لك هنا</h3>
        </div>

        </div>
</section>
<section class="faq-content-area">
    <div class="container">
        <div class="row">
            <div class="bs-example">
                <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">الشرق - برج  جرافيتي</a>
                            </h4>
                        </div>
                        <div id="collapseTwo" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent">

                                        <div class=" child2">
                                            <iframe
                                                src="https://maps.google.com/maps?q=Kuwait&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
                                        <div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[0].adressen:contactdetails[0].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                                                                    {{ $i18n.locale == 'en' ?contactdetails[0].adressen:contactdetails[0].adressar }}   
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree">الشرق - برج شرق</a>
                            </h4>
                        </div>
                        <div id="collapseThree" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent">

                                        <div class=" child2">
                                            <iframe
                                                src="https://maps.google.com/maps?q=Kuwait&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
                                        <div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[1].adressen:contactdetails[1].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                                                                                                               {{ $i18n.locale == 'en' ?contactdetails[1].adressen:contactdetails[1].adressar }}   

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapse4">الفحيحيل</a>
                            </h4>
                        </div>
                        <div id="collapse4" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent" style="background-color: #ea3c53 !important;">

                                        <div class=" child2">
                                            <iframe
                                                src="https://maps.google.com/maps?q=Kuwait&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
<div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[2].adressen:contactdetails[2].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
                                          {{ $i18n.locale == 'en' ?contactdetails[2].adressen:contactdetails[2].adressar }}   
                                            </div>
                                        </div>                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title">
                                <a data-toggle="collapse" data-parent="#accordion" href="#collapse5">السالمية</a>
                            </h4>
                        </div>
                        <div id="collapse5" class="panel-collapse collapse">
                            <div class="panel-body">
                                <div id="map-container-google-1" class="z-depth-1-half map-container" style="width:1500px;">
                                    <div class="parent" style="background-color: #ea3c53 !important;">

                                        <div class=" child2">
                                            <iframe
                                                src="https://maps.google.com/maps?q=Kuwait&t=&z=13&ie=UTF8&iwloc=&output=embed"
                                                frameborder="0"
                                                style="border:0;width:1180px;height:350px;" allowfullscreen></iframe>
                                        </div>
<div class="child1" v-if="contactdetails">
                                            <div v-html="$i18n.locale == 'en' ?contactdetails[3].adressen:contactdetails[3].adressar" class="overlay" style="font-family: 'Montserrat', sans-serif;">
 {{ $i18n.locale == 'en' ?contactdetails[3].adressen:contactdetails[3].adressar }}
                                            </div>
                                        </div>                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div><!--Office 1-->
        </div>
    </div>
</section>

<!--End slogan area-->
<!--Start footer area-->  

   
            <Footer/>
 </div>
    </div>
</template>

<script>
import "https://maps.googleapis.com/maps/api/js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'ar'],
           
            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            ceomessage: '',
            successstories: '',
            slide1image:'',
            slide2image:'',
            slide3image:'',
            techanalysis:'',
            pagedata:'',
            pagebanner:'',
            crosses:'',
            currencydata:'',
            techanalysis:'',
            contactdetails:'',
            

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
          var pathvalues = (this.$route.path).split("/");
        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'ar';
        }
       

        this.loadpagedata('contact');
        this.loadcontact();


    },
    mounted() {
        
        this.loadpagedata('contact');
        this.loadcontact();

    },

    methods: {
        loadpagedata(pagename) {
            this.$axios.get("loadpagedata", {
                params: {
                    pagename: pagename
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                          if (res.data.code == 200) {
                        this.pagedata = res.data.pagedata[0];
                        this.pagebanner=this.serverurl+'/public/pagebanners/'+res.data.pagedata[0].pagebanner;
                          }
                        else{

                            this.$router.push({ name: 'NotFound' })
                        }
                    }
                });
            

        },
         loadcontact() {

            this.$axios.get("loadcontactdata",
            )
                .then(res => {
                    if (res) {

                        this.contactdetails = res.data.contactdata;

                    }
                });
        },

    }
}
</script>
<style>
        .map-button {
            cursor: pointer;
            transition: all 0.7s;
            -webkit-transition: all 0.7s;
        }

        #google-map {
            height: 350px;
            width: 100%;
        }

        .panel-default > .panel-heading {
            color: #688ec5;
            background-color: #fffcfc;
            border-color: #ddd;
            height: 50px;
        }

        .parent {
            position: relative;
            width: 1000px;
            height: 350px;
            margin: 0px;
            background-color: #688ec5 !important;
        }

        .child1 {
            position: absolute;
            line-height:20px!important;
            top: 0;
            left: 0;
            opacity: 1;
           
            height: 350px;
            width: 350px;
            left: -1%!important;
                        background-color: #688ec5!important;

        }

        .child2 {
            z-index: 1;
            margin: 0px;
            height: 350px;
                        background-color: #ea3c53!important;

        }

    </style>
<style>
#div1::after{
    clear: none!important;
    
}
.carousel {
  background: #2f435700!important;
}
    
</style>
